import { render, staticRenderFns } from "./SelectSupplierType.vue?vue&type=template&id=4c7e09c7&"
import script from "./SelectSupplierType.vue?vue&type=script&lang=ts&"
export * from "./SelectSupplierType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7e09c7')) {
      api.createRecord('4c7e09c7', component.options)
    } else {
      api.reload('4c7e09c7', component.options)
    }
    module.hot.accept("./SelectSupplierType.vue?vue&type=template&id=4c7e09c7&", function () {
      api.rerender('4c7e09c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectSupplierType.vue"
export default component.exports